import { lighten } from '@mui/material/styles';
import { COLORS } from '../utils/Application_Constants';

export default {
    styleOverrides: {
        root: {
            fontWeight: '600',
            boxShadow: 'none',
            textTransform: 'none',
            color: 'inherit',
            minWidth: '100px',
        },
        contained: {
            boxShadow: 'none',
            '&:hover': {
                boxShadow: 'none',
            },
            color: COLORS.LT_MIDNIGHT75,
            background: COLORS.LT_MIDNIGHT5,
        },
        containedPrimary: {
            backgroundColor: COLORS.LT_JOURNEY,
            color: 'white',
            '&:hover': {
                backgroundColor: COLORS.LT_FOUNDATION,
                color: 'white',
            },
        },
        containedGrey: {
            backgroundColor: '#e0e0e0',
            '&:hover': {
                backgroundColor: '#d5d5d5',
            },
        },
        containedWarning: {
            backgroundColor: '#FEF7E5',
            color: COLORS.GOLD,
            border: `1px solid ${COLORS.GOLD}`,
        },
        outlinedPrimary: {
            background: 'transparent',
            border: `1px solid ${COLORS.LT_JOURNEY}`,
            color: COLORS.LT_JOURNEY,
        },
        text: {
            padding: '.5rem 1rem',
        },
        textPrimary: {
            color: COLORS.LT_JOURNEY,
            '&:hover': { color: COLORS.LT_JOURNEY125 },
            '&:disabled': { color: COLORS.LT_JOURNEY150 },
        },
        textError: {
            color: COLORS.LT_PEPPER,
        },
    },
    variants: [
        {
            props: (props) => props.variant.startsWith('lt-admin') && props.size === 'medium',
            style: {
                fontSize: '16px',
                fontWeight: '600',
            },
        },
        {
            props: (props) => props.variant.startsWith('lt-admin') && props.size === 'small',
            style: {
                fontSize: '14px',
                fontWeight: '600',
                lineHeight: 'normal',
                padding: '11px 12px',
                height: '39px',
            },
        },
        {
            props: { variant: 'lt-admin-outlined' },
            style: {
                border: `1px solid ${COLORS.LT_MIDNIGHT10}`,
                color: COLORS.LT_MIDNIGHT,
                '&:hover': {
                    backgroundColor: COLORS.LT_MIDNIGHT5,
                },
            },
        },
        {
            props: { variant: 'lt-admin-contained', color: 'primary' },
            style: {
                backgroundColor: COLORS.LT_JOURNEY,
                color: COLORS.WHITE,
                '&:hover': {
                    backgroundColor: COLORS.LT_JOURNEY125,
                },
                '&:disabled': {
                    color: COLORS.WHITE,
                    opacity: 0.6,
                },
            },
        },
        {
            props: { variant: 'lt-admin-outlined', color: 'error' },
            style: {
                border: `1px solid ${COLORS.LT_PEPPER}`,
                backgroundColor: 'transparent',
                color: COLORS.LT_PEPPER,
                '&:hover': {
                    backgroundColor: 'transparent',
                    borderColor: COLORS.LT_PEPPER125,
                },
                '&:disabled': {
                    color: COLORS.LT_PEPPER,
                    borderColor: lighten(COLORS.LT_PEPPER, 0.6),
                    opacity: 0.6,
                },
            },
        },
    ],
};
